import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { loadErrorText } from '../lib/loadError';

/**
 * PanelLoadError — the third state. Card P114 PR-3.
 *
 * A panel that can only say "data" or "nothing" will eventually say "nothing"
 * when it means "I could not look", and staff will believe it. This is the
 * state that says the other thing, and it is deliberately NOT styled like an
 * empty state: an empty panel is grey and calm, this is amber and offers a
 * Retry, because one of them is a fact about the business and the other is a
 * fault.
 *
 * ⚠ The text comes from loadErrorText, which assembles a sentence from an
 * allowlisted status/code — never from the provider's own message. See
 * src/lib/loadError.js for why that matters on a billing surface.
 *
 * @param {string}   what     what failed, e.g. "the payment report"
 * @param {*}        error    the rejection or `{success:false}` payload
 * @param {Function} [onRetry]
 */
export default function PanelLoadError({ what, error, onRetry }) {
  return (
    <div
      role="alert"
      data-testid="panel-load-error"
      style={{
        display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
        padding: '14px 16px', margin: '8px 0',
        background: '#FEF7E8', border: '1px solid #F5D9A0', borderRadius: 10,
        color: '#8A5A00', fontSize: 13,
      }}
    >
      <AlertTriangle size={16} style={{ flexShrink: 0 }} />
      <span style={{ flex: 1, minWidth: 180 }}>{loadErrorText(what, error)}</span>
      {typeof onRetry === 'function' && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '6px 12px', borderRadius: 8, cursor: 'pointer',
            border: '1px solid #E3B765', background: '#fff',
            color: '#8A5A00', fontSize: 12, fontWeight: 600,
          }}
        >
          <RefreshCw size={12} /> Retry
        </button>
      )}
    </div>
  );
}
